const stickerPackCache = new Map();
const stickerPackRequests = new Map();
const stickersByPackCache = new Map();
const stickersByPackRequests = new Map();

function getCompanyCacheKey(companyId) {
    return String(companyId || "default");
}

function getPackCacheKey(companyId, packId) {
    return `${getCompanyCacheKey(companyId)}:${packId}`;
}

export async function getCachedStickerPacks({ apiRequest, endpoint, companyId }) {
    const cacheKey = getCompanyCacheKey(companyId);

    if (stickerPackCache.has(cacheKey)) {
        return stickerPackCache.get(cacheKey);
    }

    if (stickerPackRequests.has(cacheKey)) {
        return stickerPackRequests.get(cacheKey);
    }

    const request = apiRequest("get", endpoint)
        .then((response) => {
            const packs = response?.data?.data || [];
            stickerPackCache.set(cacheKey, packs);
            return packs;
        })
        .finally(() => {
            stickerPackRequests.delete(cacheKey);
        });

    stickerPackRequests.set(cacheKey, request);
    return request;
}

export async function getCachedStickersByPack({ apiRequest, endpoint, companyId, packId }) {
    if (!packId) return [];

    const cacheKey = getPackCacheKey(companyId, packId);

    if (stickersByPackCache.has(cacheKey)) {
        return stickersByPackCache.get(cacheKey);
    }

    if (stickersByPackRequests.has(cacheKey)) {
        return stickersByPackRequests.get(cacheKey);
    }

    const request = apiRequest("get", `${endpoint}?packId=${packId}`)
        .then((response) => {
            const stickers = response?.data?.data || [];
            stickersByPackCache.set(cacheKey, stickers);
            return stickers;
        })
        .finally(() => {
            stickersByPackRequests.delete(cacheKey);
        });

    stickersByPackRequests.set(cacheKey, request);
    return request;
}

export function clearStickerCache(companyId) {
    if (!companyId) {
        stickerPackCache.clear();
        stickerPackRequests.clear();
        stickersByPackCache.clear();
        stickersByPackRequests.clear();
        return;
    }

    const companyKey = getCompanyCacheKey(companyId);
    stickerPackCache.delete(companyKey);
    stickerPackRequests.delete(companyKey);

    for (const cacheKey of stickersByPackCache.keys()) {
        if (cacheKey.startsWith(`${companyKey}:`)) {
            stickersByPackCache.delete(cacheKey);
        }
    }

    for (const cacheKey of stickersByPackRequests.keys()) {
        if (cacheKey.startsWith(`${companyKey}:`)) {
            stickersByPackRequests.delete(cacheKey);
        }
    }
}
